module.exports = __webpack_public_path__ + "static/media/megabit-icon.1205c42d.svg";